'use strict';

const tldToCountryCode = (code) => {
  if (!code) {
    return undefined;
  }
  const cleanCode = code.toLowerCase().trim();
  return (cleanCode === 'uk') ? 'gb' : cleanCode;
};

export default tldToCountryCode;
